import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CDFIOutreachLog } from '../../models/cdfi-outreach-log';
import { DatePipe } from '@angular/common';
import { RecordDetailsComponent } from '../../../../../shared/components/record-details/record-details.component';
import { DestroyBase } from '../../../../../shared/base-classes/destroy-component-base';
import {
  TableColumn,
  TableComponent,
} from '../../../../../shared/components/table/table.component';
import { EmailEventsPopupComponent } from '../email-events-popup/email-events-popup.component';

@Component({
  selector: 'app-cdfi-outreach-logs-table',
  standalone: true,
  imports: [
    DatePipe,
    RecordDetailsComponent,
    TableComponent,
    EmailEventsPopupComponent,
  ],
  templateUrl: './cdfi-outreach-logs-table.component.html',
  styleUrl: './cdfi-outreach-logs-table.component.scss',
})
export class CdfiOutreachLogsTableComponent extends DestroyBase {
  @Input({ required: true }) loading = false;
  @Input({ required: true }) cdfiOutreachLogs: CDFIOutreachLog[] = [];
  @Input({ required: true }) pageSize = 50;
  @Input() showActiveClientColumn = false;

  @Output() pageSizeChange = new EventEmitter<number>();

  showRecordDetails = false;
  uniqueId!: string;
  tooltipMessage = '';

  showEmailEvents = false;
  selectedOutreachId!: number;
  selectedBusinessName!: string;

  // Tooltip properties
  showOptOutTooltip = false;
  tooltipPosition = { x: 0, y: 0 };

  get tableColumns(): TableColumn[] {
    const columns: TableColumn[] = [
      { header: 'Business Name', width: '25%' },
      { header: 'Email Sent Date', width: '18%' },
      { header: 'Form View Count', width: '15%' },
      { header: 'Form Status', width: '15%' },
      { header: 'Submission Date', width: '17%' },
    ];

    if (this.showActiveClientColumn) {
      columns.push({ header: 'Active Client CDFI Count', width: '10%' });
      columns.push({ header: '', width: '10%' });
    } else {
      columns.push({ header: '', width: '10%' });
    }

    return columns;
  }

  onPageSizeChange(page: number): void {
    this.pageSizeChange.emit(page);
  }

  viewBusinessDetails(record_unique_id: string) {
    this.uniqueId = record_unique_id;
    this.showRecordDetails = true;
  }

  viewEmailEvents(outreachId: number, businessName: string) {
    this.selectedOutreachId = outreachId;
    this.selectedBusinessName = businessName;
    this.showEmailEvents = true;
  }

  showTooltip(event: MouseEvent, reason: number) {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    if (reason === 1) {
      this.tooltipMessage = 'This business has opted out of communication';
    } else if (reason === 2) {
      this.tooltipMessage = 'Deactivated by Admin';
    }
    this.tooltipPosition = {
      x: rect.left + rect.width / 2 - 150, // Center the tooltip (assuming 300px width)
      y: rect.top + 15, // Position above the row
    };
    this.showOptOutTooltip = true;
  }

  hideTooltip() {
    this.showOptOutTooltip = false;
  }
}
